import { statusMeta } from "../lib/api";

export function StatusBadge({ status, className = "" }) {
  const m = statusMeta(status);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] uppercase tracking-wider border ${m.cls} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current pulse-dot" />
      {m.label}
    </span>
  );
}
